import { useI18n } from '@/i18n/i18n-provider';
import { LogoMark } from '@/components/logo-mark';

/** Where a donor lands after backing out of the processor's hosted payment
 *  page — nothing was charged; no `Donation` was ever created for this
 *  attempt (see `GivingService.createPublicCheckout`). */
export function GiveCancelledPage() {
  const { t } = useI18n();

  return (
    <main className="auth-page">
      <div className="auth-card">
        <header className="auth-header">
          <LogoMark />
          <h1 className="auth-title">{t('giving.public.cancelledTitle')}</h1>
          <p className="auth-subtitle">{t('giving.public.cancelledBody')}</p>
        </header>
      </div>
    </main>
  );
}
